/**
 * Reading what one page left for the next in the router's state.
 *
 * `location.state` is whatever the previous navigation put there, and the
 * router types it `unknown`: a reload, the Back button or a hand-typed address
 * can leave something else there, or nothing. These read one field and return
 * it only when it has the type the page expects, rather than trusting a cast.
 */

function field(state: unknown, name: string): unknown {
  if (typeof state !== 'object' || state === null) return undefined;
  return Object.hasOwn(state, name)
    ? (state as Record<string, unknown>)[name]
    : undefined;
}

/** The field when it is a string; otherwise undefined. */
export function stateText(state: unknown, name: string): string | undefined {
  const value = field(state, name);
  return typeof value === 'string' ? value : undefined;
}

/** True only when the field is exactly `true`. */
export function stateFlag(state: unknown, name: string): boolean {
  return field(state, name) === true;
}
